import React, { useState, useEffect, createContext } from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';

export const ThemeContext = createContext();

/* ========= THEMES ========= */

const darkTheme = {
  bg: '#0b0e14',
  bgAlt: '#0f1320',
  text: '#e5e7eb',
  subText: '#9ca3af',
  card: 'rgba(255,255,255,0.04)',
  accent: '#6366f1'
};

const lightTheme = {
  bg: '#f8fafc',
  bgAlt: '#ffffff',
  text: '#0f172a',
  subText: '#475569',
  card: '#f1f5f9',
  accent: '#4f46e5'
};

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background: ${({ theme }) => theme.bg};
    color: ${({ theme }) => theme.text};
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    transition: background 0.3s ease, color 0.3s ease;
  }
`;

const ThemeLayout = ({ children }) => {
  const [mode, setMode] = useState('dark');

  useEffect(() => {
    const stored = localStorage.getItem('theme');
    if (stored) setMode(stored);
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', mode);
  }, [mode]);

  const theme = mode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ mode, setMode }}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeLayout;
